import { DEFAULT_ROUTES } from "@mais-retorno-front/constants/routes";

interface IHandleResponse {
  successAction: boolean
  newUrl?: string;
}

interface IFundTrackerFilterUseCaseRedirectProps {
  handle: (userFiltersEntries: [string, string | string[]][]) => IHandleResponse;
}

export class FundTrackerFilterUseCaseRedirect implements IFundTrackerFilterUseCaseRedirectProps {
  constructor (
    private readonly userIsPremium: boolean
  ) {}

  public handle(userFiltersEntries: [string, string | string[]][]): IHandleResponse {
    if (!this.userIsPremium && userFiltersEntries.length > 3) {
      const userFiltersWithLimit = userFiltersEntries.slice(0, 3);

      let newUserUrlWithFilters = `${DEFAULT_ROUTES.fundTracker}?${userFiltersWithLimit[0][0]}=${userFiltersWithLimit[0][1]}&${userFiltersWithLimit[1][0]}=${userFiltersWithLimit[1][1]}&${userFiltersWithLimit[2][0]}=${userFiltersWithLimit[2][1]}`;
  
      return {
        successAction: false,
        newUrl: newUserUrlWithFilters
      }
    }

    return {
      successAction: true
    }
  }
}